<template>
  <div class="row" style="height: 200px;">
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <DropSelect
            :z-index="3"
            v-bind="selectCourse"
            v-model="selectCourse.selected"
            @selected="setCourseToReport"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <VueDatePicker
            type="month"
            v-model="initialDate"
            :color="secCol"
            :maxDate="maxDate"
            :minDate="minDate"
          >
            <template #activator="{ date }">
              <DropSelect
                :date="date"
                :type="'datePicker'"
                :supTitle="'Mes del reporte'"
                :placeholder="'Seleccione el mes'"
                :icon="'schedule'"
                :zIndex="2"
              />
            </template>
          </VueDatePicker>
        </div>
      </div>
      <div class="row">
        <div class="col text-center mt-5">
          <button
            @click="show"
            :disabled="!allowDownload"
            class="button secondary"
          >
            Descargar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DropSelect from "@/components/DropSelect";

export default {
  name: "DownloadReportsView",
  components: {
    DropSelect,
  },
  computed: {
    ...mapState([
      "teacherData",
      "userData",
      "dataUrl",
      "courseList",
      "showR",
      "selectedCourses",
      "courseList",
    ]),
    allowDownload() {
      return this.selectCourse.selected > 0 && this.initialDate;
    },
  },
  data() {
    let { secCol, grayCol } = this.$store.getters;

    return {
      minDate: "",
      maxDate: "",
      secCol,
      grayCol,
      initialDate: null,
      endDate: null,
      selectType: {
        id: "type",
        supTitle: "Tipo de reporte",
        placeholder: "Seleccione el reporte",
        selected: null,
        icon: "file",
        options: [
          {
            text: "Por alumno",
            value: 1,
          },
          {
            text: "Por curso",
            value: 2,
          },
          {
            text: "Por nivel",
            value: 3,
          },
        ],
      },
      selectStudent: {
        id: "student",
        supTitle: "Alumno",
        placeholder: "Seleccione alumno",
        selected: null,
        icon: "book-reader",
        options: [
          {
            text: "Alumno 1",
            value: 1,
          },
          {
            text: "Alumno 2",
            value: 2,
          },
          {
            text: "Alumno 3",
            value: 3,
          },
        ],
      },
      selectCourse: {
        options: [],
        selected: null,
        placeholder: "Seleccione Curso o Sección",
        supTitle: "Curso o Sección",
        id: "curso",
        icon: "graduation-hat",
        valueKey: "id",
        textKey: "name",
      },
      selectLevel: {
        id: "level",
        supTitle: "Nivel",
        placeholder: "Seleccione nivel",
        selected: null,
        icon: "signal",
        options: [
          {
            text: "Nivel 1",
            value: 1,
          },
          {
            text: "Nivel 2",
            value: 2,
          },
          {
            text: "Nivel 3",
            value: 3,
          },
        ],
      },
    };
  },
  watch: {
    initialDate(newVal, oldVal) {
      if (!newVal) return;
      if (newVal == oldVal) return;

      if (this.endDate) {
        let initialDate = new Date(newVal);
        let endDate = new Date(this.endDate);

        if (endDate <= initialDate) {
          this.$notify({
            title: [
              "Fecha incorrecta",
              "La fecha inicial no puede ser mayor a la fecha final",
            ],
            type: "danger",
          });
          this.initialDate = oldVal;
          return;
        }
      }
    },
    endDate(newVal, oldVal) {
      if (!newVal) return;
      if (newVal == oldVal) return;

      if (this.initialDate) {
        let initialDate = new Date(this.initialDate);
        let endDate = new Date(newVal);

        if (endDate <= initialDate) {
          this.$notify({
            title: [
              "Fecha incorrecta",
              "La fecha final no puede ser menor a la fecha inicial",
            ],
            type: "danger",
          });
          this.endDate = oldVal;
          return;
        }
      }
    },
  },
  methods: {
    ...mapActions([
      "setShowR",
      "addCourse",
      "setDatesToReport",
      "removeAllCourses",
    ]),
    setCourseToReport(selectedCourseEvent) {
      this.removeAllCourses();
      const selectedCourse = this.selectedCourses.find(
        course => course.id === selectedCourseEvent.value
      );
      if (!selectedCourse) {
        this.addCourse(
          this.courseList.find(
            course => course.id === selectedCourseEvent.value
          )
        );
      }
    },
    getCourses() {
      this.selectCourse.options = this.courseList;
    },
    show() {
      window.scrollTo(0, 0);
      const momentDate = this.$moment(`${this.initialDate}-01`);
      const initialDate = momentDate.format("YYYY-MM-DD");
      const endDate = momentDate.endOf("month").format("YYYY-MM-DD");
      this.setDatesToReport({
        initDate: initialDate,
        finalDate: endDate,
      });
      this.setShowR({ value: true, isPendingReport: false });
    },
  },
  mounted() {
    this.getCourses();
    const currentYear = new Date().getFullYear();
    this.minDate = `${currentYear}-01-01`;
    this.maxDate = this.$moment()
      .month(this.$moment().month() - 1)
      .endOf("month")
      .format("YYYY-MM-DD");
  },
};
</script>
